var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,77.814 C50.161,77.814 42.188,69.839 42.188,60.002 C42.188,50.164 50.161,42.189 60,42.189 C69.839,42.189 77.812,50.164 77.812,60.002 C77.812,69.839 69.839,77.814 60,77.814 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,65 L105,55 L93.541,50 L93.541,50.003 C92.848,47.676 91.927,45.447 90.791,43.35 L95.355,31.715 L88.284,24.644 L76.649,29.21 C74.552,28.074 72.323,27.152 69.995,26.46 L70,26.46 L65,15 L55,15 L50,26.46 L50.005,26.46 C47.677,27.152 45.448,28.074 43.35,29.21 L31.716,24.644 L24.645,31.715 L29.21,43.349 C28.074,45.446 27.152,47.675 26.459,50.003 L26.459,50 L15,55 L15,65 L26.457,70 L26.457,69.993 C27.15,72.323 28.072,74.553 29.209,76.652 L24.645,88.284 L31.716,95.355 L43.347,90.792 C45.445,91.928 47.676,92.85 50.005,93.543 L50,93.543 L55,105 L65,105 L70,93.543 L69.995,93.543 C72.324,92.85 74.554,91.928 76.652,90.792 L88.284,95.355 L95.355,88.284 L90.792,76.651 C91.928,74.552 92.85,72.322 93.543,69.993 L93.543,70 L105,65 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.d090a62fd323a984a257bb3e1f0f7a50.svg";
export { ForwardRef as ReactComponent };